module.exports = __webpack_public_path__ + "fonts/anitta-icons.eda1f505.ttf";